module.exports = __webpack_public_path__ + "img/BO.ab9ba182.png";